module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/51_Uneven Dye Crew Socks.png";